module.exports = __webpack_public_path__ + "media/Shooting Star.38e3ef09.mp3";